"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Verpackung = void 0;
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const Article_1 = require("../Article");
class Verpackung extends Article_1.Article {
    get typ() {
        return this.model.Typ;
    }
    set typ(value) {
        this.model.Typ = value;
    }
    get preis() {
        return this.model.Preis;
    }
    set preis(value) {
        this.model.Preis = value;
    }
    get preisEK() {
        return this.model.PreisEK;
    }
    set preisEK(value) {
        this.model.PreisEK = value;
    }
    get verpackungsmittel() {
        return this.model.Verpackungsmittel;
    }
    set verpackungsmittel(value) {
        this.model.Verpackungsmittel = value;
    }
    get gewicht() {
        return echain_shared_quantities_1.Q.optional(this.model.Gewicht);
    }
    set gewicht(value) {
        this.model.Gewicht = value === null || value === void 0 ? void 0 : value.quantity;
    }
}
exports.Verpackung = Verpackung;
//# sourceMappingURL=Verpackung.js.map